export const getDatePercentageDifference = (createdAt, deadline) => {
    const start = new Date(createdAt);
    const end = new Date(deadline);

    return `calc(${Math.round(
        ((new Date() - start) / (end - start)) * 100
    )}% - 4px)`;
};
